import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import { saveAs } from 'file-saver';
import certificate from '../assets/files/certificate1.pdf'; 

export const formatDateDetails = (dateString: string) => {
  const date = new Date(dateString);

  return {
    Full_Date: date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }),
    Month: date.toLocaleDateString("en-US", { month: "short" }),
    Year: date.getFullYear(),
    Date: date.getDate(),
    Day: date.toLocaleDateString("en-US", { weekday: "long" }),
  };
};

export const formatFromDateDetails = (dateString: string) => {
  const date = new Date(dateString);

  return {
    From_Full_Date: date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }),
    From_Month: date.toLocaleDateString("en-US", { month: "short" }),
    From_Year: date.getFullYear(),
    From_Date: date.getDate(),
    From_Day: date.toLocaleDateString("en-US", { weekday: "long" }),
  };
};

export const formatTime = (time: string) => {
  if (time) {
    const [hours, minutes] = time?.split(":");
    let formattedTime = `${parseInt(hours) % 12 || 12}:${minutes} ${
      parseInt(hours) >= 12 ? "PM" : "AM"
    }`;
    return formattedTime;
  }
  return "N/A";
};

export const formatUrl = (url: string | undefined) => {
  if (url && !url.startsWith("https://") && !url.startsWith("http://")) {
    return `https://${url}`;
  }
  return url;
};

export const getFormattedDate = (
  addYears = 0,
  subtractDays = 0,
  subtractMonths = 0
) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + addYears);
  date.setDate(date.getDate() - subtractDays);
  date.setMonth(date.getMonth() - subtractMonths);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// export const getMembershipExpiryStatus = (expiryDateStr: string) => {
//   if (!expiryDateStr) {
//     return {
//       label: "No Expiry",
//       color: "#6c757d",
//       bgColor: "#e0e0e0",
//     };
//   }

//   const expiryDate = new Date(expiryDateStr);
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);
//   expiryDate.setHours(0, 0, 0, 0);

//   const diffInTime = expiryDate.getTime() - today.getTime();
//   const diffInDays = Math.ceil(diffInTime / (1000 * 3600 * 24));

//   if (diffInDays < 0) {
//     return {
//       label: "Expired",
//       color: "red",
//       bgColor: "#e0e0e0",
//     };
//   } else {
//     return {
//       label: "Not expired",
//       color: "green",
//       bgColor: "#e0e0e0",
//     };
//   }
// }

export const showRenewButton = (expiryDateStr?: string): boolean => {
  if (!expiryDateStr) return false;

  const today = new Date();
  const expiryDate = new Date(expiryDateStr);
  const oneMonthFromNow = new Date();
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);

  return (
    expiryDate < today || (expiryDate >= today && expiryDate <= oneMonthFromNow)
  );
};

export const getMembershipStatusColor = (status?: string) => {
  switch (status) {
    case "Approved":
      return { color: "green" };
    case "Active":
      return { color: "green" };
    case "Pending":
      return { color: "#ffa415" };
    case "Rejected":
      return { color: "red" };
    case "Expired":
      return { color: "darkred" };
    default:
      return { color: "#6c757d" };
  }
};

export const generatePDF = async (memberName: string) => {
  try {
    const existingPdfBytes = await fetch(certificate).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    const fontSize = 24;
    const pageWidth = firstPage.getWidth();
    const textWidth = font.widthOfTextAtSize(memberName, fontSize);
    const centerX = (pageWidth - textWidth) / 2;

    firstPage.drawText(memberName, {
      x: centerX,
      y: 340,
      size: fontSize,
      font,
      color: rgb(0, 0, 0),
    });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const newTab = window.open(url, '_blank');
    if (newTab) {
      newTab.document.title = `${memberName}_certificate.pdf`;
    }

  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export const downloadPDF = async (memberName: string) => {
  try {
    const existingPdfBytes = await fetch(certificate).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    const fontSize = 24;
    const pageWidth = firstPage.getWidth();
    const textWidth = font.widthOfTextAtSize(memberName, fontSize);
    const centerX = (pageWidth - textWidth) / 2;

    firstPage.drawText(memberName, {
      x: centerX,
      y: 340,
      size: fontSize,
      font,
      color: rgb(0, 0, 0),
    });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${memberName}_certificate.pdf`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};

export const truncateText = (markdownText: string, charLimit: number): string => {
  if (markdownText.length <= charLimit) return markdownText;
  return markdownText.slice(0, charLimit).trimEnd() + " ...";
};
